import { useEffect } from "react";

// Fija el titulo de la pestana. Sin titulo (null), no toca el que haya.
export default function useDocumentTitle(title) {
    useEffect(() => {
        if (title) document.title = title;
    }, [title]);
}
